import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import gameState from "slotworks/model/game-state";
import RainbowStacksRespinRecord from "integration/revolver/schema/respin-record";
import RainbowStacksSpinRecord from "integration/revolver/schema/spin-record";
import RainbowStacksFreespinRecord from "integration/revolver/schema/freespin-record";

export default class IsRespinDecision extends Decision {
    public evaluate() {
        const record = gameState.getCurrentGame().latestRecord();

        if(record instanceof RainbowStacksRespinRecord) {
            return Exit.True;
        }

        if((record instanceof RainbowStacksSpinRecord ||
                record instanceof RainbowStacksFreespinRecord) &&
                record.triggersRespin) {
            return Exit.True;
        }

        return Exit.False;
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/decisions/is-respin.ts